import { defineComponent, ref, onMounted, onBeforeUnmount, watch, createElementBlock, openBlock, createElementVNode, normalizeStyle } from 'vue';
import videojs from 'video.js';
import { useElementVisibility } from './basler-components.es378.js';

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "MediaVideo",
  props: {
    media: {}
  },
  setup(__props) {
    const props = __props;
    const videoPlayer = ref(null);
    let player = null;
    const wrapper = ref(null);
    const wrapperIsVisible = useElementVisibility(wrapper);
    onMounted(() => {
      if (videoPlayer.value) {
        player = videojs(
          videoPlayer.value,
          {
            controls: props.media.displayPlayerInterface,
            autoplay: props.media.autoplay,
            muted: props.media.autoplay,
            loop: typeof props.media.loop !== "undefined" ? props.media.loop : false,
            preload: props.media.preload || "none",
            playsinline: typeof props.media.playsinline !== "undefined" ? props.media.playsinline : true,
            fluid: true,
            sources: [
              {
                src: props.media.mp4,
                type: "video/mp4"
              },
              {
                src: props.media.webm,
                type: "video/webm"
              }
            ],
            poster: props.media.posterImage
          },
          function onPlayerReady() {
          }
        );
      }
    });
    onBeforeUnmount(() => {
      if (player) {
        player.dispose();
      }
    });
    watch(
      wrapperIsVisible,
      (newVal) => {
        if (player && props.media.autoplay === true) {
          if (newVal) {
            player.play();
          } else {
            player.pause();
          }
        }
      },
      { immediate: true, deep: true }
    );
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "media-video",
        ref_key: "wrapper",
        ref: wrapper
      }, [
        createElementVNode("video", {
          ref_key: "videoPlayer",
          ref: videoPlayer,
          class: "video-js vjs-default-skin vjs-big-play-centered",
          style: normalizeStyle(
            _ctx.media.backgroundColor != null ? `background-color: ${_ctx.media.backgroundColor};` : "background-color: transparent;"
          )
        }, null, 4)
      ], 512);
    };
  }
});

export { _sfc_main as default };
